import images from "../../ImageVariables";
import "../SCSS/styles.css";
function SurveyExpirationPage() {
  return (
    <div className="survey-expiration-main-conatiner">
      <div className="survey-expiration-main-wrapper">
        <div className="survey-expiration-svg-cover">
          <div className="survey-expiration-svg-wrapper">
            <img
              className="survey-expiration-img"
              src={images.surveyExpiration}
              alt="survey-expiration"
            />
          </div>
        </div>
        <div className="survey-expiration-header-description-cover">
          <div className="survey-expiration-header-text-wrapper">
            <div className="survey-expiration-header-text-cover">
              <h3 className="survey-expiration-header">
                Your survey has been expired
              </h3>
            </div>
            <div className="survey-expiration-header-description-text-cover">
              <p className="survey-expiration-description">
                This survey you're looking for is no longer available
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SurveyExpirationPage;
